import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ReviewEntities } from 'client/data/models/dealer-reviews';
import {
  DEALER_PROPS,
  DEFAULT_REVIEWS_TYPE,
  REVIEWS_SALES,
  REVIEWS_SERVICE,
  REVIEWS_ALL,
} from 'client/constants/dealer-reviews';
import { DealerReviewsOverallRating } from 'site-modules/dealerships/components/dealer-review-overall-rating/dealer-review-overall-rating';
import { DealerReviewsList } from 'site-modules/dealerships/components/dealer-reviews-list/dealer-reviews-list';
import { UserReview } from 'site-modules/dealerships/components/user-review/user-review';
import { WriteAReviewLink } from 'site-modules/shared/components/write-review-link/write-review-link';
import { WriteReviewLinks } from 'site-modules/dealerships/components/write-review-links/write-review-links';

export function DealerReviewGoodView({
  overallData = {},
  featuredReview = null,
  reviewsType = DEFAULT_REVIEWS_TYPE,
  params,
  showroomPage = '',
  isMobile = false,
}) {
  // rating will be 0 if there are no reviews from the last two years, should not display it
  const isDisplayOverallRating = !!overallData.averageRating;

  return (
    <div className="dealer-review-good-view">
      <div
        className={classNames('d-flex justify-content-center flex-column gap-2_5 mb-1 mb-md-2', {
          'flex-md-row': isDisplayOverallRating,
        })}
      >
        <div>
          {isDisplayOverallRating && <DealerReviewsOverallRating rating={overallData} reviewsType={reviewsType} />}
          <WriteReviewLinks
            showroomPage={showroomPage}
            reviewsType={reviewsType}
            params={params}
            classes={classNames({ 'mt-1': isDisplayOverallRating })}
          />
        </div>
        {featuredReview && (
          <div>
            <UserReview review={featuredReview} params={params} />
            {isMobile && <hr className="mt-1_5 mb-0" />}
          </div>
        )}
      </div>
      <div>
        <div className="d-flex flex-column flex-md-row justify-content-md-between row-gap-1 rounded-16 bg-blue-100 p-1 p-md-1_5">
          <span className="size-16 fw-bold text-cool-gray-10">Have feedback for this dealer?</span>
          {reviewsType === REVIEWS_ALL && (
            <div className="d-flex align-items-start column-gap-2 row-gap-1 flex-column flex-md-row">
              <WriteAReviewLink params={params} reviewsType={REVIEWS_SALES} showroomPage={showroomPage} noFollow />
              <WriteAReviewLink params={params} reviewsType={REVIEWS_SERVICE} showroomPage={showroomPage} noFollow />
            </div>
          )}
          {reviewsType !== REVIEWS_ALL && (
            <WriteAReviewLink params={params} reviewsType={reviewsType} showroomPage={showroomPage} noFollow />
          )}
        </div>

        <DealerReviewsList reviewsType={reviewsType} overallData={overallData} params={params} isMobile={isMobile} />
      </div>
    </div>
  );
}

DealerReviewGoodView.propTypes = {
  overallData: ReviewEntities.OverallRatingEntity,
  params: DEALER_PROPS.isRequired,
  reviewsType: PropTypes.string,
  featuredReview: ReviewEntities.ReviewEntity,
  showroomPage: PropTypes.string,
  isMobile: PropTypes.bool,
};
